module.exports = __webpack_public_path__ + "static/img/huai2.068ab06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/huai2.jpg
// module id = wusA
// module chunks = 0